import React from 'react';
import { useTranslation } from 'react-i18next';

const ProcessSection = () => {
  const { t } = useTranslation('implantology');
  const steps = [
    {
      step: "01",
      title: t('process.steps.0.title'),
      description: t('process.steps.0.description'),
    },
    {
      step: "02",
      title: t('process.steps.1.title'),
      description: t('process.steps.1.description'),
    },
    {
      step: "03",
      title: t('process.steps.2.title'),
      description: t('process.steps.2.description'),
    },
    {
      step: "04",
      title: t('process.steps.3.title'),
      description: t('process.steps.3.description'),
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute top-20 right-0 w-80 h-80 bg-dental-light/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-0 w-60 h-60 bg-dental-coral/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4 text-gradient-primary inline-block relative after:content-[''] after:absolute after:-bottom-2 after:left-1/4 after:right-1/4 after:h-1 after:bg-dental-tertiary after:rounded-full reveal" data-direction="up">
            {t('process.heading')}
          </h2>
          <p className="text-xl text-dental-dark/80 max-w-3xl mx-auto reveal" data-direction="up">
            {t('process.intro')}
          </p>
        </div>
        
        <div className="space-y-12 max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="flex flex-col md:flex-row items-start gap-6 reveal"
              data-direction={index % 2 === 0 ? "left" : "right"}
            >
              <div className="flex-shrink-0 w-16 h-16 rounded-full bg-dental-light/50 flex items-center justify-center text-2xl font-bold text-dental">
                {step.step}
              </div>
              <div>
                <h3 className="text-xl font-display font-bold mb-2 text-dental-dark">
                  {step.title}
                </h3>
                <p className="text-dental-dark/70">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
